<template>
  <div class="menu__weeks">
    <v-window v-model="onboarding" show-arrows reverse>
      <v-window-item
        v-for="(groups, index) in groupedWeeks"
        :key="`card-${index}`"
      >
        <div class="m-5">
          <div class="row slider__fechas">
            <div
              v-for="(group, index2) in groups"
              :key="index2"
              class="col-3 slider__bloq"
            >
              <div
                :class="{ active: activeWeek === group.week }"
                class="week-bloq"
                @click="disable ? '' : sendWeek(group)"
              >
                {{ group['interval'] }}
                <p class="mb-0">Semana {{ group.week }}</p>
              </div>
            </div>
          </div>
        </div>
      </v-window-item>
    </v-window>

    <a href="" class="return__link" @click.prevent="calculateWeeks()">
      <v-icon large color="green"> mdi-calendar-check-outline </v-icon>
    </a>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import moment from 'moment';
  export default {
    props: ['disableSendWeek'],
    data() {
      return {
        onboarding: 1,
        groupedWeeks: [],
        activeWeek: null,
        disable: false,
        currentDate: moment().format('YYYY-MM-DD'),
      };
    },
    watch: {
      disableSendWeek(newVal) {
        this.disable = newVal; // Actualiza el valor de `disable` con el valor de `disableSendWeek`
      },
    },
    mounted() {
      this.calculateWeeks();
    },
    methods: {
      calculateFirstDayOfLastYear() {
        const firstDayOfLastYear = moment().subtract(1, 'year').startOf('year');
        const dayOfWeek = firstDayOfLastYear.day();
        return firstDayOfLastYear.subtract(dayOfWeek, 'days');
      },
      calculateWeeks() {
        (this.disable = true), (this.groupedWeeks = []);
        // Calcular el primer día del año anterior
        const start = this.calculateFirstDayOfLastYear();
        // Calcular el último día del próximo año
        const end = moment(start).add(3, 'year').add(1, 'day'); // Agregar 1 día a la fecha final
        const days = end.diff(start, 'days');
        const weeks = [];
        let weekNumber = 1;
        let year = start.year();
        for (let i = 0; i < days; i += 7) {
          const weekStart = moment(start).add(i, 'days');
          const weekEnd = moment.min(moment(weekStart).add(6, 'days'), end);
          const weekInterval = `${weekStart.format(
            'DD MMM'
          )} - ${weekEnd.format('DD MMM')}`;
          if (weekStart.year() > year) {
            year = weekStart.year();
            weekNumber = 1;
          } else if (weekStart.month() === 0 && weekStart.date() <= 7) {
            // Ajustar número de semana para la primera semana del año
            weekNumber = 1;
          }
          const week = {
            week: weekNumber,
            interval: weekInterval,
            weekStart: moment(weekStart).format('YYYY-MM-DD'),
            weekEnd: moment(weekEnd).format('YYYY-MM-DD'),
            year: year,
          };
          weeks.push(week);
          weekNumber++;
        }
        const dateRange = `${start.format('D/M/YYYY')} - ${moment(end)
          .subtract(1, 'day')
          .format('D/M/YYYY')}`;
        this.$emit('dateRange', dateRange);
        for (let i = 0; i < weeks.length; i += 4) {
          this.groupedWeeks.push(weeks.slice(i, i + 4));
        }

        // Verifica en qué grupo se encuentra la fecha actual
        for (let i = 0; i < this.groupedWeeks.length; i++) {
          const group = this.groupedWeeks[i];
          for (const week of group) {
            if (
              this.currentDate >= week.weekStart &&
              this.currentDate <= week.weekEnd
            ) {
              this.onboarding = i;
              this.sendWeek(week);
            }
          }
        }
      },
      sendWeek(group) {
        this.activeWeek = group.week;
        this.$emit('sendWeek', {
          inicio: group.weekStart,
          fin: group.weekEnd,
          intervalo: group.interval,
          semana: group.week,
        });
      },
    },
  };
</script>

<style scoped>
  .active {
    color: red;
  }
  .week-bloq {
    cursor: pointer;
    text-align: center;
  }
  .slider__bloq {
    border-right: 1px solid #c1c1c1;
    padding: 5px 0 5px 0;
  }
  .slider__bloq:last-child {
    border-right: 0;
  }
  .menu__weeks {
    position: relative;
  }
  .return__link {
    position: absolute;
    right: -40px;
    top: 45px;
  }
</style>
